<template>
  <div>
    <cabecalho-pagina
      :titulo="$t('modulos.item.titulos.historico')"
      sem-registros
      sem-botao-ok
      sem-filtro
    />
    <div class="mt-1 mb-4">
      <v-chip class="mr-1" small>
        {{ $t('modulos.item.tabela.codigo') }}: {{ badges.codigo }}
      </v-chip>
      <v-chip v-if="badges.fabricante" class="mr-1" small>
        {{ $t('modulos.item.tabela.fabricante') }}: {{ badges.fabricante }}
      </v-chip>
    </div>
    <tabela-padrao-prime-vue
      v-model="tabela.selecionados"
      :mostrar-acoes="false"
      class="mt-2"
      :colunas="tabela.colunas"
      :dados="tabela.dados"
      ajustar-altura-linha
      filtros-com-colunas
      :mostrar-seletor="false"
      :quantidade-itens="tabela.quantidadeItens"
      :por-pagina="tabela.porPagina"
      :quantidade-paginas="tabela.quantidadePaginas"
      :pagina="tabela.paginaAtual"
      @paginar="buscarHistorico"
      @filtrarGlobal="filtrarGlobal"
      @filtroGlobal="filtroGlobal"
      @nova-ordenacao="ordenacaoColuna"
    />
    <v-divider class="my-5" />
    <div class="d-flex align-center justify-end">
      <botao-padrao outlined color="secondary" class="mr-2" @click="voltar">
        <v-icon>$mdiArrowLeft</v-icon>
        {{ $t('geral.botoes.voltar') }}
      </botao-padrao>
    </div>
  </div>
</template>

<script>
import CabecalhoPagina from '@components/layout/CabecalhoPagina.vue';
import ItemService from '@common/services/cadastros/ItemService';
import helpers from '@common/utils/helpers';
import moment from 'moment';
export default {
  components: {
    CabecalhoPagina,
  },
  props: {
    id: { type: String, default: null },
  },
  data() {
    return {
      badges: {
        codigo: '',
        fabricante: '',
      },
      retornoUrl: null,
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'data',
            text: this.$t('modulos.item.historico.dataHora'),
            sortable: false,
            formatter: (v) => {
              if (v) return this.formatDateTime(v);
            },
          },
          {
            value: 'valor',
            text: this.$t('modulos.item.historico.valorVenda'),
            sortable: false,
            formatter: (v) => helpers.formatarMoeda(v),
          },
          {
            value: 'horasExecucaoPadrao',
            text: this.$t('modulos.item.historico.horasExecucaoPadrao'),
            sortable: false,
          },
          {
            value: 'usuario.nome',
            text: this.$t('modulos.item.historico.usuario'),
            sortable: false,
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
      },
      filtroAplicado: { filter: '' },
      colunaOrdenada: '',
    };
  },
  created() {
    this.retornoUrl = this.$route.query.retorno;
  },
  mounted() {
    this.$store.dispatch(
      'Layout/alterarTituloPagina',
      this.$t('modulos.item.titulos.historico')
    );
    if (this.id) {
      this.buscarHistorico(this.id);
      this.buscarItem(this.id);
    }
  },
  methods: {
    buscarHistorico: function (
      id,
      paginaAtual = this.tabela.paginaAtual,
      porPagina = this.tabela.porPagina
    ) {
      let parametros = {
        page: paginaAtual,
        amountPerPage: porPagina,
        sort: this.colunaOrdenada,
        ...helpers.formattingParameters(this.filtroAplicado),
      };
      this.$store.dispatch('Layout/iniciarCarregamento');
      ItemService.buscarHistorico(id, parametros)
        .then((res) => {
          this.tabela.dados = res.data.items;

          this.tabela.quantidadeItens = res.data.totalItems;
          this.tabela.quantidadePaginas = res.data.totalPages;
          this.tabela.paginaAtual = paginaAtual;
          this.tabela.porPagina = porPagina;
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.item.erros.buscarHistorico'));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscarItem: function (id) {
      this.$store.dispatch('Layout/iniciarCarregamento');
      ItemService.buscar(id)
        .then((res) => {
          const dados = res.data;
          this.badges = {
            codigo: dados.codigo,
            fabricante: dados.participanteFabricante?.nome,
          };
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.item.erros.id_invalido'));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    formatDateTime: function (datetime) {
      return moment(datetime).format('DD/MM/YYYY - HH[h]mm');
    },
    voltar: function () {
      this.$router.push({ name: 'item' });
    },
    filtroGlobal(v) {
      this.filtroAplicado.filter = v;
    },
    filtrarGlobal() {
      this.buscarHistorico();
    },
    ordenacaoColuna(ordem) {
      this.colunaOrdenada = ordem;
      this.buscarHistorico();
    },
  },
};
</script>
